// Mesma regra do "Fluxo de caixa" do Runner (TPeriodo.Create em delphi/Contabil2/uFluxoDatas.pas):
// cada grupo começa no dia seguinte ao fim do anterior e o primeiro período de cada grupo vai só
// até o fim da unidade corrente (semana até domingo, mês até o último dia...).
// Semestres e Anos não existem no Runner; seguem a mesma lógica. Limites iguais aos UpDown do DFM.

export var TIPOS_PERIODO = [
    { tipo: 'days', nome: 'Dias', max: 999 },
    { tipo: 'weeks', nome: 'Semanas', max: 52 },
    { tipo: 'fortnights', nome: 'Quinzenas', max: 48 },
    { tipo: 'months', nome: 'Meses', max: 24 },
    { tipo: 'quarters', nome: 'Trimestres', max: 8 },
    { tipo: 'semesters', nome: 'Semestres', max: 4 },
    { tipo: 'years', nome: 'Anos', max: 5 }
];

function ultimoDiaDoMes(ano, mes) {
    return new Date(ano, mes + 1, 0);
}

function somarDias(data, dias) {
    return new Date(data.getFullYear(), data.getMonth(), data.getDate() + dias);
}

var calcularFim = {
    days: function (inicio) {
        return inicio;
    },
    weeks: function (inicio) {
        return somarDias(inicio, (7 - inicio.getDay()) % 7);
    },
    fortnights: function (inicio) {
        return inicio.getDate() < 16
            ? new Date(inicio.getFullYear(), inicio.getMonth(), 15)
            : ultimoDiaDoMes(inicio.getFullYear(), inicio.getMonth());
    },
    months: function (inicio) {
        return ultimoDiaDoMes(inicio.getFullYear(), inicio.getMonth());
    },
    // Trimestre comercial: o Runner vem com "Trimestres comerciais" marcado.
    quarters: function (inicio) {
        return ultimoDiaDoMes(inicio.getFullYear(), Math.floor(inicio.getMonth() / 3) * 3 + 2);
    },
    semesters: function (inicio) {
        return ultimoDiaDoMes(inicio.getFullYear(), inicio.getMonth() < 6 ? 5 : 11);
    },
    years: function (inicio) {
        return new Date(inicio.getFullYear(), 11, 31);
    }
};

export function paraISO(data) {
    return data.getFullYear() + '-' + ('0' + (data.getMonth() + 1)).slice(-2) + '-' + ('0' + data.getDate()).slice(-2);
}

function paraBR(data) {
    return ('0' + data.getDate()).slice(-2) + '/' + ('0' + (data.getMonth() + 1)).slice(-2) + '/' + data.getFullYear();
}

// quantidades: { days: 2, months: 3, ... } — tipo ausente ou zero não gera período.
export function gerarPeriodos(dataBase, quantidades) {
    var periodos = [];
    var inicio = new Date(dataBase.getFullYear(), dataBase.getMonth(), dataBase.getDate());

    TIPOS_PERIODO.forEach(function (definicao) {
        var quantidade = Math.min(parseInt(quantidades[definicao.tipo], 10) || 0, definicao.max);
        for (var i = 0; i < quantidade; i++) {
            var fim = calcularFim[definicao.tipo](inicio);
            periodos.push({
                tipo: definicao.tipo,
                nomeTipo: definicao.nome,
                inicio: inicio,
                fim: fim,
                chave: paraISO(inicio),
                chaveFim: paraISO(fim),
                descricao: inicio.getTime() === fim.getTime() ? paraBR(fim) : paraBR(inicio) + ' a ' + paraBR(fim)
            });
            inicio = somarDias(fim, 1);
        }
    });

    return periodos;
}
